/**
 * Finnish message keys are authoritative; values come from per-surface JSON.
 * Per-key translator constraints live in notes.json beside the message sources.
 */

import { adminFi } from './fi/admin.js';
import { adminAnalyticsFi } from './fi/adminAnalytics.js';
import { cmsFi } from './fi/cms.js';
import { cmsArchiveFi } from './fi/cmsArchive.js';
import { cmsArticleFi } from './fi/cmsArticle.js';
import { cmsBannerFi } from './fi/cmsBanner.js';
import { cmsBenefitFi } from './fi/cmsBenefit.js';
import { cmsCatalogFi } from './fi/cmsCatalog.js';
import { cmsContentLocaleFi } from './fi/cmsContentLocale.js';
import { cmsCopyUnitToLocaleFi } from './fi/cmsCopyUnitToLocale.js';
import { cmsCreateFi } from './fi/cmsCreate.js';
import { cmsDiscardStagedEditFi } from './fi/cmsDiscardStagedEdit.js';
import { cmsDuplicateFi } from './fi/cmsDuplicate.js';
import { cmsEditorFormFi } from './fi/cmsEditorForm.js';
import { cmsHomeCardFi } from './fi/cmsHomeCard.js';
import { cmsLifecycleConfirmFi } from './fi/cmsLifecycleConfirm.js';
import { cmsLifecycleToastFi } from './fi/cmsLifecycleToast.js';
import { cmsOrderFi } from './fi/cmsOrder.js';
import { cmsPreviewFi } from './fi/cmsPreview.js';
import { cmsRichTextFi } from './fi/cmsRichText.js';
import { cmsScheduleFi } from './fi/cmsSchedule.js';
import { cmsScheduleRowMarkerFi } from './fi/cmsScheduleRowMarker.js';
import { cmsStandaloneCreateFi } from './fi/cmsStandaloneCreate.js';
import { cmsUploadFi } from './fi/cmsUpload.js';
import { cmsVideoListingFi } from './fi/cmsVideoListing.js';
import { commonFi } from './fi/common.js';
import { homeFi } from './fi/home.js';
import { memberFi } from './fi/member.js';
import { memberMessagingCatalogueFi } from './fi/memberMessagingCatalogue.js';
import { memberMessagingComposeFi } from './fi/memberMessagingCompose.js';
import { myCasesFi } from './fi/myCases.js';
import { myDataDeletionFi } from './fi/myDataDeletion.js';
import { myDataExportFi } from './fi/myDataExport.js';
import { onboardingFi } from './fi/onboarding.js';
import { shellFi } from './fi/shell.js';

export const fi = {
  ...commonFi,
  ...homeFi,
  ...shellFi,
  ...memberFi,
  ...memberMessagingComposeFi,
  ...myCasesFi,
  ...myDataDeletionFi,
  ...myDataExportFi,
  ...memberMessagingCatalogueFi,
  ...onboardingFi,
  ...cmsFi,
  ...cmsArchiveFi,
  ...cmsBenefitFi,
  ...cmsCatalogFi,
  ...cmsCreateFi,
  ...cmsEditorFormFi,
  ...cmsHomeCardFi,
  ...cmsOrderFi,
  ...cmsPreviewFi,
  ...cmsScheduleFi,
  ...cmsVideoListingFi,
  ...cmsDiscardStagedEditFi,
  ...cmsContentLocaleFi,
  ...cmsCopyUnitToLocaleFi,
  ...cmsDuplicateFi,
  ...cmsBannerFi,
  ...cmsArticleFi,
  ...cmsRichTextFi,
  ...cmsLifecycleToastFi,
  ...cmsLifecycleConfirmFi,
  ...cmsScheduleRowMarkerFi,
  ...cmsStandaloneCreateFi,
  ...cmsUploadFi,
  ...adminFi,
  ...adminAnalyticsFi,
} as const;

/** `MessageKeys` derives from `fi` — keeps "Finnish authors the keys" syntactically obvious. Re-exported from `./index.ts`. */
export type MessageKeys = keyof typeof fi;
